import styled from '@emotion/styled';

export const FormVerticalContainer = styled.div<{ gap?: string; width?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap ?? '28px'};
  width: ${({ width }) => width ?? 'auto'};
`;
